import { render, staticRenderFns } from "./SpellConfig.vue?vue&type=template&id=3a6601f3&scoped=true&"
import script from "./SpellConfig.vue?vue&type=script&lang=js&"
export * from "./SpellConfig.vue?vue&type=script&lang=js&"
import style0 from "./SpellConfig.vue?vue&type=style&index=0&id=3a6601f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6601f3",
  null
  
)

export default component.exports